import { render, staticRenderFns } from "./UserComments.vue?vue&type=template&id=3281f235&scoped=true&"
import script from "./UserComments.vue?vue&type=script&lang=ts&"
export * from "./UserComments.vue?vue&type=script&lang=ts&"
import style0 from "./UserComments.vue?vue&type=style&index=0&id=3281f235&lang=scss&scoped=true&"
import style1 from "./UserComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3281f235",
  null
  
)

export default component.exports